import React, { useRef, useState } from 'react'
import AlertTemplateMessage from '../AlertTemplate/AlertTemplateMessage'
import {  MULTI_TIME_ZONE } from '../../../config';
import * as XLSX from 'xlsx';
import { bulkUploadACS, bulkUploadCamera, bulkUploadPanel, uploadBulkImport, validateBulkImport, generateBulkRtspUrls } from '../../../services/configurationServices';
import { ConvertDateToUTC } from '../../../utils/utils';
import { ErrorToast } from '../../../CustomHooks/ErrorToast';
import { SuccessToast } from '../../../CustomHooks/SuccessToast';
import { CSVLink } from "react-csv";
import Swal from 'sweetalert2';

const entityData = [
  { id: 1, name: 'Customer-Site' },
  { id: 2, name: 'CCTV Device' },
  { id: 3, name: 'IDS Panel Device' },
  { id: 4, name: 'ACS Device' },
  { id: 5, name: 'Fire Panel Device' },
  { id: 6, name: 'RTU Device' }
]

let customer_required_fields = ["Customer Name","Country","State","City","Address"]

// let cctv_required_fields = [
//   "brand","ipaddress","communicationport","username","password","port","channelnumber","livestreamtype",
//   "playbackstreamtype","devicename","sitename","enablelivetranscoding","enableplaybacktranscoding","cctvtype",
//   "httpport","enabletwowaydevice","ptz","timezone","monitoringservice","alertservice","hmservice","videobackupservice", "devicestage"
// ]
 let cctv_required_fields =[
  "brand","sitezonename","cctvtype","devicename","channelnumber","ipaddress",
    "username","password","communicationport","httpport","port",
    "livestreamtype","playbackstreamtype","enablelivetranscoding","enableplaybacktranscoding",
    "enabletwowaydevice","ptz","timezone","monitoringservice","alertservice","hmservice","videobackupservice", "devicestage"
 ]

let panel_required_fields = ["brand","ipaddress","sitezonename","name","zonetype","zonename","zonenumber","portnumber","interfaceusername","interfacepassword","timezone","alertservice","hmservice"]

let acs_required_fields = ["brand","sitezonename","ipaddress","portnumber","username","password","devicename","identifier","timezone","alertservice","hmservice"]

let fire_panel_required_fields = ["brand","sitezonename","devicetype", "ipaddress","portnumber","username","password","devicename","identifier","timezone","alertservice","hmservice"]

let rtu_required_fields = ["brand","sitezonename","devicetype","ipaddress","portnumber","username","password","devicename","identifier","timezone","alertservice","hmservice"]

const customer_site_link = '/bulkImportTemplates/MH_Customer_Site_Bulk_Import_Template.xlsx'
const cctv_device_link = '/bulkImportTemplates/MH_CCTV_Device_Bulk_Import_Template.csv'
const ids_panel_device_link = '/bulkImportTemplates/MH_IDSPanel_Device_Bulk_Import_Template.csv'
const acs_device_link = '/bulkImportTemplates/MH_ACS_Device_Bulk_Import_Template.csv'
const rtu_device_link = '/bulkImportTemplates/MH_RTU_Device_Bulk_Import_Template.csv'
const firepanel_device_link = '/bulkImportTemplates/MH_FirePanel_Device_Bulk_Import_Template.csv'
const master_data_link = '/bulkImportTemplates/MH_Master_Data_Sheet.xlsx'

const Import = () => {
  const codeRef = useRef(null);
  const hiddenPanelFileInput = useRef(null);
  const [copied, setCopied] = useState(false);
  const [selectedEntity, setSelectedEntity] = useState(0);
  const [importedFileName, setImportedFileName] = useState(null)
  const [sheetUploadPayload, setSheetUploadPayload] = useState(null);
  const [fileData, setFileData] = useState(null);
  const [sheetCompliant, setSheetCompliant] = useState(false);
  const [faildListToDownload, setFaildListToDownload] = useState([])
  const [sucessListToDownload, setSucessListToDownload] = useState([])
  const [failedDevices, setFailedDevices] = useState(null);
  const [successDevices, setSuccessDevices] = useState(null);
  const [customerResult, setCustomerResult] = useState([]);
  const [siteResult, setSiteResult] = useState([]);
  const [headers, setHeaders] = useState(null);
  const [isBlankSheet, setIsBlankSheet] = useState(false);
  const [uploadSpinner, setUploadSpinner] = useState(false);
  
  const [errorMessage, setErrorMessages] = useState([]);

  const textRef = useRef();

  const divBottomRef = useRef(null);

  const containerRef = useRef(null);

  const code = `Row 1 : Customer Name is invalid, should not contain special characters.`;

  const handleCopy = () => {
    const text = textRef.current.innerText;
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    });
  };

  const downloadFile = () => {
    const link = document.createElement("a");
    const master = document.createElement("a");
    let selectedTemplate = entityData.find((item) => item.id == selectedEntity);
    if (selectedTemplate.name === 'CCTV Device') {
      link.href = cctv_device_link;
    } else if (selectedTemplate.name === 'IDS Panel Device') {
      link.href = ids_panel_device_link;
    }
    else if (selectedTemplate.name === 'ACS Device') {
      link.href = acs_device_link;
    }
    else if (selectedTemplate.name === 'Fire Panel Device') {
      link.href = firepanel_device_link;
    }
    else if (selectedTemplate.name === 'RTU Device') {
      link.href = rtu_device_link;
    }else if(selectedTemplate.name === "Customer-Site") {
      link.href = customer_site_link;
    } 
    else {
      link.href = customer_site_link;
    }
    master.href = master_data_link;
    document.body.appendChild(link);
    document.body.appendChild(master);
    master.click();
    setTimeout(() => {
      link.click();
      document.body.removeChild(link);
      document.body.removeChild(master);
      Swal.fire({
        icon: 'info',
        title: 'Template and Master Sheet Downloaded.',
        html: `
         <p><strong>The downloaded template contains dummy data.</strong> Please remove it and enter your actual data before uploading.</p>
             <p>You may refer to the dummy data as examples to understand the expected format and valid values.</p>
    <p><strong>The master sheet has also been downloaded</strong> — refer to it for valid values for specific columns in the template.</p>
        `
      })
    }, 500)
  }

  const handleBrowse = (event) => {
    event.preventDefault()
    hiddenPanelFileInput.current.click();
  };

  const handleUploaderChange = async (e) => {
    const file = e.target.files[0];
    checkExcelHasData(file);
    handleFile(file);
    setImportedFileName(file['name']);

    const data = await file.arrayBuffer();
    const workbook = XLSX.read(data, { type: 'array' });

    const sheetNames = workbook.SheetNames;

    let arr = [];

    let selectedTemplate = entityData.find((item) => item.id == selectedEntity);
    let selectedSheetName = "";
    if (selectedTemplate.name === 'CCTV Device') {
      selectedSheetName = "CCTV_Device"
    } else if (selectedTemplate.name === 'IDS Panel Device') {
      selectedSheetName = "Panel_Device"
    }
    else if (selectedTemplate.name === 'ACS Device') {
      selectedSheetName = "ACS_Device"
    }
    else if (selectedTemplate.name === 'Fire Panel Device') {
      selectedSheetName = "Fire Panel_Device"
    }
    else if (selectedTemplate.name === 'RTU Device') {
      selectedSheetName = "RTU_Device"
    } else {
      selectedSheetName = "Other"
    }

    // Function to trim all string values in an object or array
    const trimObjectValues = (obj) => {
      if (Array.isArray(obj)) {
        return obj.map(item => trimObjectValues(item));
      } else if (obj !== null && typeof obj === 'object') {
        const trimmedObj = {};
        for (const key in obj) {
          if (obj.hasOwnProperty(key)) {
            trimmedObj[key] = trimObjectValues(obj[key]);
          }
        }
        return trimmedObj;
      } else if (typeof obj === 'string') {
        return obj.trim();
      } else {
        return obj;
      }
    };

    //The if block is for multiple sheets(Customer-Site Sheet)
    //The else block is for single sheet(All Devices Bulk Import Individually)
    if (sheetNames.length > 1) {
      sheetNames.forEach(sheetName => {
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);
        const trimmedData = trimObjectValues(jsonData);

        let obj = {
          "type": sheetName,
          "dataset": trimmedData
        }
        arr.push(obj);
      });
    } else {
      sheetNames.forEach(sheetName => {
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);
        const trimmedData = trimObjectValues(jsonData);
        setFileData(trimmedData);
        let obj = {
          "type": selectedSheetName,
          "dataset": trimmedData
        }
        arr.push(obj);
      });
    }

    let loggedInUser = JSON.parse(localStorage.getItem('user'))
    let OrganizationMasterID = loggedInUser?.OrganizationMasterID
    let payload = {
      userId: localStorage.getItem('UserID'),
      data: arr,
      organizationMasterId: OrganizationMasterID
    }
    setSheetUploadPayload(payload);
    setSheetCompliant(false);
  }

  console.log({sheetUploadPayload});

  const handleFile = (file) => {
    const reader = new FileReader();
  
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
  
      // Get the first sheet
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
  
      // Convert sheet to JSON, just the first row
      const headers = [];
      const range = XLSX.utils.decode_range(worksheet['!ref']);
  
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cellAddress = XLSX.utils.encode_cell({ r: range.s.r, c: C });
        const cell = worksheet[cellAddress];
        const header = cell ? cell.v : `UNKNOWN ${C}`;
        headers.push(header);
      }
      setHeaders(headers);
    };
  
    reader.readAsArrayBuffer(file);
  };

  const checkExcelHasData = (file) => {
    const reader = new FileReader();
  
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
  
      // For example, checking the first sheet
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
  
      // Convert entire sheet to JSON
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: "", raw: true });
      if (jsonData.length > 0) {
        setIsBlankSheet(false);
      } else {
        setIsBlankSheet(true);
      }
    };
  
    reader.readAsArrayBuffer(file);
  };

  const frontendValidate = () => {
    let selectedTemplate = entityData.find((item) => item.id == selectedEntity);
    if (selectedTemplate.name === 'CCTV Device') {
      return compareHeaders(headers, cctv_required_fields)
    } else if(selectedTemplate.name === 'IDS Panel Device') {
      return compareHeaders(headers, panel_required_fields)
    }
    else if(selectedTemplate.name === 'ACS Device') {
      return compareHeaders(headers, acs_required_fields)
    }
    else if(selectedTemplate.name === 'Fire Panel Device') {
      return compareHeaders(headers, fire_panel_required_fields)
    }
    else if(selectedTemplate.name === 'RTU Device') {
      return compareHeaders(headers, rtu_required_fields)
    }else if(selectedTemplate.name === 'Customer-Site'){
      return compareHeaders(headers, customer_required_fields)
    } 
    else{
      return true;
    }
  }

  const compareHeaders = (headerOne, headerTwo) => {
    if(headerOne.length !== headerTwo.length){
      return false;
    } 
    for(let i=0; i<headerOne.length; i++){
      if(headerOne[i] !== headerTwo[i]){
        return false;
      }
    }
    return true;
  }
  
  const validateSheet = () => {
    let checkSheetHeaders = frontendValidate();
    
    if(!checkSheetHeaders){
      let arr = [{
        "message": "Sheet headers do not match the selected entity."
      }]
      setErrorMessages(arr)
      ErrorToast("Sheet is invalid — please check the error details.")
      return;
    }
    if(isBlankSheet && selectedEntity != 1){
      let arr = [{
        "message": "The sheet is empty. Please add some data before uploading."
      }]
      setErrorMessages(arr)
      ErrorToast("Sheet is invalid — please check the error details.")
      return;
    }
    let payload = sheetUploadPayload;
    validateBulkImport(payload)
      .then((res) => {
        if (res.Status == "success") {
          if(res.Data.customer.length === 0 && res.Data.site.length === 0 && res.Data.cctv.length === 0 && res.Data.panel.length === 0 && res.Data.acs.length === 0 && res.Data.rtu.length === 0 && res.Data.firepanel.length === 0) {
            setSheetCompliant(true);
            setErrorMessages([]);
            SuccessToast("Sheet is valid and ready for upload.")
          }else{
            let temp = [...res.Data.customer, ...res.Data.site, ...res.Data.cctv, ...res.Data.panel, ...res.Data.acs, ...res.Data.rtu, ...res.Data.firepanel];
            setErrorMessages(temp);
            setSheetCompliant(false);
            ErrorToast("Sheet is invalid — please check the error details.")
          }
        }
      })
      .catch(err => console.log(err));
  }

  const bulkUpload = () => {
    let selectedTemplate = entityData.find((item) => item.id == selectedEntity);
    setUploadSpinner(true);
    if (selectedTemplate.name === 'CCTV Device') {
      cctvBulkUpload();
    } else if (selectedTemplate.name === 'IDS Panel Device') {
      onPanelBulkUpload();
    }
    else if (selectedTemplate.name === 'ACS Device') {
      onAcsBulkUpload("ACS")
    }
    else if (selectedTemplate.name === 'Fire Panel Device') {
      onAcsBulkUpload("Fire Panel")
    }
    else if (selectedTemplate.name === 'RTU Device') {
      onAcsBulkUpload("RTU")
    } else if(selectedTemplate.name === 'Customer-Site'){
      customerSiteBulkUpload();
    }else{
      customerSiteBulkUpload();
    }
  }

  const customerSiteBulkUpload = () => {
    let loggedInUser = JSON.parse(localStorage.getItem('user'))
    let OrganizationMasterID = loggedInUser?.OrganizationMasterID
    let payload = {
      userId: localStorage.getItem('UserID'),
      data: sheetUploadPayload?.data,
      organizationMasterId: OrganizationMasterID
    }
    uploadBulkImport(payload)
      .then((res) => {
        if (res.Status == "success") {
          setUploadSpinner(false);
          SuccessToast(res.Message);
          setCustomerResult(res.Data.customer)
          setSiteResult(res.Data.site)
          reset();
          scrollToBottom();
        }else{
          setUploadSpinner(false);
          ErrorToast("Bulk upload failed.")
        }
      }).catch(err => {
        console.log(err)
        setUploadSpinner(false);
        ErrorToast("Bulk upload failed.")
      });
  }

  const handleDownload = () => {
    const wb = XLSX.utils.book_new();
    const customerSheet = XLSX.utils.json_to_sheet(customerResult);
    const siteSheet = XLSX.utils.json_to_sheet(siteResult);
    if(customerResult.length > 0){
      XLSX.utils.book_append_sheet(wb, customerSheet, 'Customer')
    }
    if(siteResult.length > 0){
      XLSX.utils.book_append_sheet(wb, siteSheet, 'Site')
    }

    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([wbout], { type: 'application/octet-stream' });
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = 'customer_site_upload_result.xlsx';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);

  }
// =====================================================
// CCTV BULK UPLOAD
// =====================================================
const cctvBulkUpload = async () => {
    try {
        setUploadSpinner(true);
        // =================================================
        // SAFE ARRAY
        // =================================================
        const rows = Array.isArray(fileData) ? fileData : Object.values(fileData || {});
        // =================================================
        // NORMALIZE STREAM
        // =================================================
        const normalizeStreamValue = (value) => {
            const stream = (value?.toString().trim().toLowerCase() || "");
            if (stream === "main" || stream === "1" || stream === "01") {
                return "Main";
            }
            if (stream === "sub" || stream === "2" || stream === "02") {
                return "Sub";
            }
            if (stream === "ter" || stream === "third" || stream === "3" || stream === "03") {
                return "Third";
            }
            return "Main";
        };

        
        // =================================================
        // BUILD CLEAN PAYLOAD
        // =================================================
        const preparedRows = rows.map(
            (element) => {
              const brand = element.brand?.trim().toLowerCase();
              const liveType = element.livestreamtype?.toLowerCase();
              const playbackType = element.playbackstreamtype?.toLowerCase();

              const streamMappings = {
                hikvision: {
                  main: "01",
                  sub: "02",
                  ter: "03",
                },
                "hikvision-hybrid": {
                  main: "01",
                  sub: "02",
                  ter: "03",
                },
                "tp-link": {
                  main: "1",
                  sub: "2",
                  ter: "3",
                },
                default: {
                  main: "0",
                  sub: "1",
                  ter: "2",
                },
              };

              // Select mapping based on brand
              const mapping =
                streamMappings[brand] || streamMappings.default;

              // Assign values
              const liveStreamType = mapping[liveType] || "";
              const playbackStreamType = mapping[playbackType] || "";
                return {
                    brandName: element["brand"]?.toString().trim() || "",
                    privateIPAddress: element["ipaddress"] || "",
                    communicationPort: element["communicationport"]?.toString() || "",
                    userName: element["username"]?.toString().trim() || "",
                    password: element["password"]?.toString().trim() || "",
                    port: element["port"]?.toString() || "554",
                    channelNumber: element["channelnumber"]?.toString() || "1",
                    // =============================
                    // IMPORTANT
                    // Backend expects:
                    // Main / Sub / Third
                    // =============================
                    liveStreamType: normalizeStreamValue(element["livestreamtype"]),
                    playbackStreamType: normalizeStreamValue(element["playbackstreamtype"]),
                    liveStreamTypeNumber: liveStreamType,
                    playbackStreamTypeNumber: playbackStreamType,
                    cameraName: element["devicename"]?.toString().trim() || "",
                    siteName: element["sitezonename"]?.toString().trim() || "",
                    isTranscoded: element["enablelivetranscoding"]?.toString() || "",
                    isPlaybackTranscoded: element["enableplaybacktranscoding"]?.toString() || "",
                    cctvtype: element["cctvtype"]?.toString().trim() || "",
                    httpPort: element["httpport"]?.toString() || "",
                    isTwoWayEnabled: element["enabletwowaydevice"]?.toString() || "",
                    ptz: element["ptz"]?.toString() || "",
                    monitoringservice: element["monitoringservice"]?.toString() || "",
                    alertservice: element["alertservice"]?.toString() || "",
                    hmservice: element["hmservice"]?.toString() || "",
                    videobackupservice: element["videobackupservice"]?.toString() || "",
                    devicestage: element["devicestage"]?.toString().trim() || "",
                    timezone: MULTI_TIME_ZONE ? (element["timezone"]?.toString().trim() || "") : ""
                };
            });
        // =================================================
        // STEP 1
        // GENERATE RTSP URLS
        // =================================================
        const rtspResponse = await generateBulkRtspUrls({
            data: preparedRows
        });
        // =================================================
        // GENERATED ROWS
        // =================================================
        console.log({
            rtspResponse
        })
        const updatedRows = rtspResponse?.Data || [];
        console.log("updatedRows", updatedRows);
        // =================================================
        // USER DETAILS
        // =================================================
        const createdtime = ConvertDateToUTC(new Date());
        const loggedInUser = JSON.parse(localStorage.getItem("user"));
        const userid = localStorage.getItem("UserID");
        // =================================================
        // FINAL BULK UPLOAD PAYLOAD
        // =================================================
        const payload = {
            userUniqueId: loggedInUser?.Id,
            userID: userid,
            organizationMasterID: loggedInUser?.OrganizationMasterID,
            createdOn: createdtime,
            data: updatedRows
        };
        // =================================================
        // STEP 2
        // BULK UPLOAD
        // =================================================
        const res = await bulkUploadCamera(payload);
        // =================================================
        // SUCCESS
        // =================================================
        if (res?.Status === "success") {
            successFailedSheetCreator(res.Data, "CCTV");
            SuccessToast("Bulk upload completed successfully.");
            reset();
            scrollToBottom();
        }
        // =================================================
        // FAILED
        // =================================================
        else {
            ErrorToast("Bulk Import Failed.");
            successFailedSheetCreator(res.Data, "CCTV");
        }
    }
    // ===================================================
    // ERROR
    // ===================================================
    catch (error) {
        console.error("Bulk upload failed", error);
        ErrorToast("Bulk Import Failed.");
    }
    // ===================================================
    // FINALLY
    // ===================================================
    finally {
        setUploadSpinner(false);
    }
};

  const onPanelBulkUpload = () => {
      if (true) {  
        const actualData = fileData;
        var panelDataObj = [];
        Object.keys(actualData).map((item, index) => {
          let element = actualData[item];
          var objToAppend = {
            brand: element["brand"].toString().trim(),
            ipAddress: element["ipaddress"],
            siteName: element["sitezonename"].toString().trim(),
            name: element["name"].toString().trim(),
            zoneType: element["zonetype"].toString().trim(),
            zoneName: element["zonename"].toString().trim(),
            zoneNumber: element["zonenumber"].toString(),
            // "interfaceName": element[7],
            portNumber: element["portnumber"].toString(),
            interfaceUsername: element["interfaceusername"].toString().trim(),
            interfacePassword: element["interfacepassword"].toString().trim(),
            alertservice: element["alertservice"].toString(),
            hmservice: element["hmservice"].toString()
          };
          if (MULTI_TIME_ZONE) {
            objToAppend.timezone = element["timezone"].toString().trim();
          }
          panelDataObj.push(objToAppend);
        });  
        var createdtime = ConvertDateToUTC(new Date());
        // Dot Net API for Panel Bulk Upload.
        let loggedInUser = JSON.parse(localStorage.getItem("user"))
        let userid = localStorage.getItem("UserID");
        let newobjToPass = {
          userUniqueId: loggedInUser.UserUniqueID || loggedInUser.userUniqueID,
          userID: userid,
          createdOn: createdtime,
          data: panelDataObj,
          organizationMasterID: loggedInUser?.OrganizationMasterID,
        };
  
        bulkUploadPanel(newobjToPass).then((resp) => {
          if (resp && resp.Status === "success") {
            // SuccessToast(resp.Message);
            successFailedSheetCreator(resp.Data, "IDS Panel")
            SuccessToast("Bulk upload completed successfully.")
            reset();
            scrollToBottom();
            setUploadSpinner(false);
          } else {
            ErrorToast("Bulk Import Failed.")
            setUploadSpinner(false);
            successFailedSheetCreator(resp.Data, "IDS Panel")
          }
        });
      } 
  }

const onAcsBulkUpload = (interfaceType) => {
      let panelDataObj = [];
      const actualData = fileData;
      Object.keys(actualData).map((item, index) => {
        let element = actualData[item];
        var objToAppend = {
          brand: element["brand"].trim(),
          sitezonename: element["sitezonename"].toString().trim(),
          ipaddress: element["ipaddress"],
          portnumber: element["portnumber"].toString(),
          username: element["username"].toString().trim(),
          password: element["password"].toString().trim(),
          devicename: element["devicename"].toString().trim(),
          identifier: element["identifier"].toString().trim(),
          alertservice: element["alertservice"].toString(),
          hmservice:element["hmservice"].toString()
        };
        if (MULTI_TIME_ZONE) {
          objToAppend.timezone = element["timezone"].toString().trim();
        }
        if(interfaceType == "RTU" || interfaceType == "Fire Panel"){
          objToAppend.devicetype = element["devicetype"].toString().trim()
        }
        panelDataObj.push(objToAppend);
      });

      var createdtime = ConvertDateToUTC(new Date());
      let loggedInUser = JSON.parse(localStorage.getItem("user"))
      let userid = localStorage.getItem("UserID");
      let newobjToPass = {
        userUniqueId: loggedInUser?.Id,
        userID: userid,
        createdOn: createdtime,
        data: panelDataObj,
        organizationMasterID: loggedInUser?.OrganizationMasterID,
      };
      bulkUploadACS(newobjToPass,interfaceType).then((resp) => {
        if (resp && resp.Status === "success") {
          // setAcsBulkUploadResponse(resp.Data);
          successFailedSheetCreator(resp.Data, interfaceType)
          SuccessToast("Bulk upload completed successfully.");
          reset();
          scrollToBottom();
          setUploadSpinner(false);
        } else {
          ErrorToast("Bulk Import Failed.")
          setUploadSpinner(false);
          successFailedSheetCreator(resp.Data, interfaceType)
        }
      });
    
  };

  const successFailedSheetCreator = (deviceBulkUploadResponse, type) => {
    if (type === "CCTV") {
      var failedDevList = deviceBulkUploadResponse && deviceBulkUploadResponse['CameraFailedList'] && deviceBulkUploadResponse['CameraFailedList'].length
      var successDevList = deviceBulkUploadResponse && deviceBulkUploadResponse['CameraSuccessList'] && deviceBulkUploadResponse['CameraSuccessList'].length
      if (failedDevList && failedDevList != undefined) {
        setFailedDevices(failedDevList)

      }
      if (successDevList && successDevList != undefined) {
        setSuccessDevices(successDevList)
      }
      if ((deviceBulkUploadResponse['CameraFailedList'] && deviceBulkUploadResponse['CameraFailedList'].length > 0) ||
        (deviceBulkUploadResponse['CameraSuccessList'] && deviceBulkUploadResponse['CameraSuccessList'].length > 0)) {
        const failedList = deviceBulkUploadResponse['CameraFailedList']
        const successList = deviceBulkUploadResponse['CameraSuccessList']
        const newList = [];
        const newList2 = [];
        
        // if (MULTI_TIME_ZONE) {
        //   newList.push(["brand", "ipaddress", "communicationport", "httpport", "username", "password", "port", "channelnumber", "livestreamtype", "playbackstreamtype", "devicename", "branch", "enablelivetranscoding", "enableplaybacktranscoding"/* , "interfacename" */, "cctvtype", "enabletwowaydevice", "ptz", "timezone", "monitoringservice", "alertservice", "hmservice", "videobackupservice", "devicestage","reason"])
        // } else {
        //   newList.push(["brand", "ipaddress", "communicationport", "httpport", "username", "password", "port", "channelnumber", "livestreamtype", "playbackstreamtype", "devicename", "branch", "enablelivetranscoding", "enableplaybacktranscoding"/* , "interfacename" */, "cctvtype", "enabletwowaydevice", "ptz", "monitoringservice", "alertservice", "hmservice", "videobackupservice", "devicestage","reason"])
        // }
        if (MULTI_TIME_ZONE) {
          newList.push(["brand","sitezonename" ,"cctvtype","devicename","channelnumber","ipaddress", "username", "password","communicationport","httpport","port","livestreamtype","playbackstreamtype","enablelivetranscoding","enableplaybacktranscoding","enabletwowaydevice","ptz", "timezone", "monitoringservice", "alertservice", "hmservice", "videobackupservice", "devicestage","reason"])
        } else {
          newList.push(["brand","sitezonename" ,"cctvtype","devicename","channelnumber","ipaddress", "username", "password","communicationport","httpport","port","livestreamtype","playbackstreamtype","enablelivetranscoding","enableplaybacktranscoding","enabletwowaydevice","ptz", "timezone", "monitoringservice", "alertservice", "hmservice", "videobackupservice", "devicestage","reason"])
        }

        for (let i = 0; i < failedList.length; i++) {
          const element = failedList[i];
          let covertLiveStreamType = "";
          let convertPlaybackStreamType = "";

          if (element["brandName"].toLowerCase() == "hikvision" || element["brandName"].toLowerCase() == "hikvision-hybrid") {
            if (element["liveStreamTypeNumber"] == "01") {
              covertLiveStreamType = "main"
            } else if (element["liveStreamTypeNumber"] == "02") {
              covertLiveStreamType = "sub"
            } else if (element["liveStreamTypeNumber"] == "03") {
              covertLiveStreamType = "ter"
            }

            if (element["playbackStreamTypeNumber"] == "01") {
              convertPlaybackStreamType = "main"
            } else if (element["playbackStreamTypeNumber"] == "02") {
              convertPlaybackStreamType = "sub"
            } else if (element["playbackStreamTypeNumber"] == "03") {
              convertPlaybackStreamType = "ter"
            }
          } else {
            if (element["liveStreamTypeNumber"] == "0") {
              covertLiveStreamType = "main"
            } else if (element["liveStreamTypeNumber"] == "1") {
              covertLiveStreamType = "sub"
            } else if (element["liveStreamTypeNumber"] == "2") {
              covertLiveStreamType = "ter"
            }

            if (element["playbackStreamTypeNumber"] == "0") {
              convertPlaybackStreamType = "main"
            } else if (element["playbackStreamTypeNumber"] == "1") {
              convertPlaybackStreamType = "sub"
            } else if (element["playbackStreamTypeNumber"] == "2") {
              convertPlaybackStreamType = "ter"
            }
          }


          
          // if (MULTI_TIME_ZONE) {
          //   newList.push([element["brandName"], element["privateIPAddress"], element["communicationPort"], element["httpPort"], element["userName"], element["password"], element["port"], element["channelNumber"], covertLiveStreamType, convertPlaybackStreamType, element["cameraName"], element["siteName"], element["isTranscoded"], element["isPlaybackTranscoded"], /* element['interfaceName'], */ element["cctvtype"], element["isTwoWayEnabled"], element["ptz"], element["timezone"], element["monitoringservice"], element["alertservice"], element["hmservice"], element["videobackupservice"], element["devicestage"], element["message"]])
          // } else {
          //   newList.push([element["brandName"], element["privateIPAddress"], element["communicationPort"], element["httpPort"], element["userName"], element["password"], element["port"], element["channelNumber"], covertLiveStreamType, convertPlaybackStreamType, element["cameraName"], element["siteName"], element["isTranscoded"], element["isPlaybackTranscoded"], /* element['interfaceName'], */ element["cctvtype"], element["isTwoWayEnabled"], element["ptz"], element["monitoringservice"], element["alertservice"], element["hmservice"], element["videobackupservice"],element["devicestage"] ,element["message"]])

          // }

          if (MULTI_TIME_ZONE) {
            newList.push([element["brandName"], element["siteName"],element["cctvtype"],element["cameraName"],element["channelNumber"], element["privateIPAddress"],element["userName"], element["password"], element["communicationPort"], element["httpPort"],element["port"], covertLiveStreamType, convertPlaybackStreamType, element["isTranscoded"], element["isPlaybackTranscoded"], element["isTwoWayEnabled"], element["ptz"], element["timezone"], element["monitoringservice"], element["alertservice"], element["hmservice"], element["videobackupservice"], element["devicestage"], element["message"]])
          } else {
            newList.push([element["brandName"], element["siteName"],element["cctvtype"],element["cameraName"],element["channelNumber"], element["privateIPAddress"],element["userName"], element["password"], element["communicationPort"], element["httpPort"],element["port"], covertLiveStreamType, convertPlaybackStreamType, element["isTranscoded"], element["isPlaybackTranscoded"], element["isTwoWayEnabled"], element["ptz"], element["timezone"], element["monitoringservice"], element["alertservice"], element["hmservice"], element["videobackupservice"], element["devicestage"], element["message"]])

          }
        }

        // Success Count
        
        // if (MULTI_TIME_ZONE) {
        //   newList2.push(["brand", "ipaddress", "communicationport", "httpport", "username", "password", "port", "channelnumber", "livestreamtype", "playbackstreamtype", "devicename", "branch", "enablelivetranscoding", "enableplaybacktranscoding"/* , "interfacename" */, "cctvtype", "enabletwowaydevice", "ptz", "timezone", "monitoringservice", "alertservice", "hmservice", "videobackupservice","devicestage", "reason"])

        // } else {
        //   newList2.push(["brand", "ipaddress", "communicationport", "httpport", "username", "password", "port", "channelnumber", "livestreamtype", "playbackstreamtype", "devicename", "branch", "enablelivetranscoding", "enableplaybacktranscoding"/* , "interfacename" */, "cctvtype", "enabletwowaydevice", "ptz", "monitoringservice", "alertservice", "hmservice", "videobackupservice","devicestage" ,"reason"])
        // }
        if (MULTI_TIME_ZONE) {
          newList2.push(["brand","sitezonename" ,"cctvtype","devicename","channelnumber","ipaddress", "username", "password","communicationport","httpport","port","livestreamtype","playbackstreamtype","enablelivetranscoding","enableplaybacktranscoding","enabletwowaydevice","ptz", "timezone", "monitoringservice", "alertservice", "hmservice", "videobackupservice", "devicestage","reason"])
        } else {
          newList2.push(["brand","sitezonename" ,"cctvtype","devicename","channelnumber","ipaddress", "username", "password","communicationport","httpport","port","livestreamtype","playbackstreamtype","enablelivetranscoding","enableplaybacktranscoding","enabletwowaydevice","ptz", "timezone", "monitoringservice", "alertservice", "hmservice", "videobackupservice", "devicestage","reason"])
        }

        for (let i = 0; i < successList.length; i++) {
          const element = successList[i];
          let covertLiveStreamType = "";
          let convertPlaybackStreamType = "";

          if (element["brandName"].toLowerCase() == "hikvision" || element["brandName"].toLowerCase() == "hikvision-hybrid") {
            if (element["liveStreamTypeNumber"] == "01") {
              covertLiveStreamType = "main"
            } else if (element["liveStreamTypeNumber"] == "02") {
              covertLiveStreamType = "sub"
            } else if (element["liveStreamTypeNumber"] == "03") {
              covertLiveStreamType = "ter"
            }

            if (element["playbackStreamTypeNumber"] == "01") {
              convertPlaybackStreamType = "main"
            } else if (element["playbackStreamTypeNumber"] == "02") {
              convertPlaybackStreamType = "sub"
            } else if (element["playbackStreamTypeNumber"] == "03") {
              convertPlaybackStreamType = "ter"
            }
          } else {
            if (element["liveStreamTypeNumber"] == "0") {
              covertLiveStreamType = "main"
            } else if (element["liveStreamTypeNumber"] == "1") {
              covertLiveStreamType = "sub"
            } else if (element["liveStreamTypeNumber"] == "2") {
              covertLiveStreamType = "ter"
            }

            if (element["playbackStreamTypeNumber"] == "0") {
              convertPlaybackStreamType = "main"
            } else if (element["playbackStreamTypeNumber"] == "1") {
              convertPlaybackStreamType = "sub"
            } else if (element["playbackStreamTypeNumber"] == "2") {
              convertPlaybackStreamType = "ter"
            }
          }

          
          // if (MULTI_TIME_ZONE) {
          //   newList2.push([element["brandName"], element["privateIPAddress"], element["communicationPort"], element["httpPort"], element["userName"], element["password"], element["port"], element["channelNumber"], covertLiveStreamType, convertPlaybackStreamType, element["cameraName"], element["siteName"], element["isTranscoded"], element["isPlaybackTranscoded"], /* element['interfaceName'], */ element["cctvtype"], element["isTwoWayEnabled"], element["ptz"], element["timezone"], element["monitoringservice"], element["alertservice"], element["hmservice"], element["videobackupservice"], element["devicestage"] ,element["message"]])
          // } else {
          //   newList2.push([element["brandName"], element["privateIPAddress"], element["communicationPort"], element["httpPort"], element["userName"], element["password"], element["port"], element["channelNumber"], covertLiveStreamType, convertPlaybackStreamType, element["cameraName"], element["siteName"], element["isTranscoded"], element["isPlaybackTranscoded"], /* element['interfaceName'], */ element["cctvtype"], element["isTwoWayEnabled"], element["ptz"], element["monitoringservice"], element["alertservice"], element["hmservice"], element["videobackupservice"], element["devicestage"] ,element["message"]])
          // }
          if (MULTI_TIME_ZONE) {
            newList2.push([element["brandName"], element["siteName"],element["cctvtype"],element["cameraName"],element["channelNumber"], element["privateIPAddress"],element["userName"], element["password"], element["communicationPort"], element["httpPort"],element["port"], covertLiveStreamType, convertPlaybackStreamType, element["isTranscoded"], element["isPlaybackTranscoded"], element["isTwoWayEnabled"], element["ptz"], element["timezone"], element["monitoringservice"], element["alertservice"], element["hmservice"], element["videobackupservice"], element["devicestage"], element["message"]])
          } else {
            newList2.push([element["brandName"], element["siteName"],element["cctvtype"],element["cameraName"],element["channelNumber"], element["privateIPAddress"],element["userName"], element["password"], element["communicationPort"], element["httpPort"],element["port"], covertLiveStreamType, convertPlaybackStreamType, element["isTranscoded"], element["isPlaybackTranscoded"], element["isTwoWayEnabled"], element["ptz"], element["timezone"], element["monitoringservice"], element["alertservice"], element["hmservice"], element["videobackupservice"], element["devicestage"], element["message"]])

          }
          
        }

        if (newList && newList.length > 1) {
          setFaildListToDownload(newList)
        }
        if (newList2 && newList2.length > 1) {
          setSucessListToDownload(newList2)
        }

      }
    } else if (type === "IDS Panel") {
      const panelFailedLst = deviceBulkUploadResponse && deviceBulkUploadResponse?.panelFailedList;

      if (panelFailedLst && panelFailedLst.length > 0) {
        let failedList = []
        // if (sensorFailedLst.length > 0) failedList = failedList.concat(sensorFailedLst)
        if (panelFailedLst.length > 0) {
          for (let i = 0; i < panelFailedLst.length; i++) {
            console.log("FailedPanel", panelFailedLst[i]);
            // for (let j = 0; j < panelFailedLst[i].sensorLst.length; j++) {
            let temp = {};

            temp['sitezonename'] = panelFailedLst[i]['siteName']
            temp['brand'] = panelFailedLst[i]['brand']
            temp['deviceID'] = panelFailedLst[i]['deviceID']
            temp['message'] = panelFailedLst[i]['message']
            // temp['panelIp'] = panelFailedLst[i]['panelIp']  
            temp['panelIp'] = panelFailedLst[i]['ipAddress']
            // temp['panelName'] = panelFailedLst[i]['panelName']
            temp['panelName'] = panelFailedLst[i]['name']
            temp['status'] = panelFailedLst[i]['status']
            /*  temp['sensorLst'] = {
               'zoneName': panelFailedLst[i].sensorLst[j]['zoneName'],
               'zoneNumber': panelFailedLst[i].sensorLst[j]['zoneNumber'],
               'zoneType': panelFailedLst[i].sensorLst[j]['zoneType']
             } */
            temp['zoneName'] = panelFailedLst[i]['zoneName']
            temp['zoneNumber'] = panelFailedLst[i]['zoneNumber']
            temp['zoneType'] = panelFailedLst[i]['zoneType']
            // temp['interfaceName'] = panelFailedLst[i]['interfaceName']
            temp['portNumber'] = panelFailedLst[i]['portNumber']
            temp['interfaceUsername'] = panelFailedLst[i]['interfaceUsername']
            temp['interfacePassword'] = panelFailedLst[i]['interfacePassword']
            temp['alertservice'] = panelFailedLst[i]['alertservice']
            temp['hmservice'] = panelFailedLst[i]['hmservice']
            if (MULTI_TIME_ZONE) {
              temp['timezone'] = panelFailedLst[i]['timezone']
            }
            failedList.push(temp)
            // }
          }
        }
        let failedDevList = failedList.length;
        if (failedDevList && failedDevList !== undefined) {
          setFailedDevices(failedDevList)
        }

        const newList = []
        if (MULTI_TIME_ZONE) {
          newList.push(["brand", "ipaddress", "sitezonename", "name", "zonetype", "zonename", "zonenumber", "portnumber", "interfaceusername", "interfacepassword", "timezone", "alertservice", "hmservice",
            /* "interfacename",  */
            "errorcause"])
        } else {
          newList.push(["brand", "ipaddress", "sitezonename", "name", "zonetype", "zonename", "zonenumber", "portnumber", "interfaceusername", "interfacepassword", "alertservice", "hmservice",
            /* "interfacename",  */
            "errorcause"])
        }
        for (let i = 0; i < failedList.length; i++) {
          const element = failedList[i];
          // newList.push([element["brand"], element["panelIp"], element["branch"], element["panelName"], element['sensorLst']["zoneType"], element['sensorLst']["zoneName"], element['sensorLst']["zoneNumber"], element['interfaceName'], element["message"]])
          if (MULTI_TIME_ZONE) {
            newList.push([element["brand"], element["panelIp"], element["sitezonename"], element["panelName"], element["zoneType"], element["zoneName"], element["zoneNumber"], /* element['interfaceName'], */
            element["portNumber"], element["interfaceuserName"], element["interfacePassword"], element["timezone"], element["alertservice"], element["hmservice"],
            element["message"]])
          } else {
            newList.push([element["brand"], element["panelIp"], element["sitezonename"], element["panelName"], element["zoneType"], element["zoneName"], element["zoneNumber"], /* element['interfaceName'], */
            element["portNumber"], element["interfaceuserName"], element["interfacePassword"], element["alertservice"], element["hmservice"],
            element["message"]])

          }
        }

        if (newList && newList.length > 1) {
          setFaildListToDownload(newList)
        }
      } //end

      const panelSuccessList = deviceBulkUploadResponse && deviceBulkUploadResponse?.panelSuccessList
      if (panelSuccessList && panelSuccessList.length > 0) {
        let successList = []

        if (panelSuccessList.length > 0) {
          for (let i = 0; i < panelSuccessList.length; i++) {
            let temp = {}
            temp['sitezonename'] = panelSuccessList[i]['siteName']
            temp['brand'] = panelSuccessList[i]['brand']
            temp['deviceID'] = panelSuccessList[i]['deviceID']
            temp['message'] = panelSuccessList[i]['message']
            temp['panelIp'] = panelSuccessList[i]['ipAddress']
            temp['panelName'] = panelSuccessList[i]['name']
            temp['status'] = panelSuccessList[i]['status']
            temp['zoneName'] = panelSuccessList[i]['zoneName']
            temp['zoneNumber'] = panelSuccessList[i]['zoneNumber']
            temp['zoneType'] = panelSuccessList[i]['zoneType']
            // temp['interfaceName'] = panelSuccessList[i]['interfaceName']
            temp['portNumber'] = panelSuccessList[i]['portNumber']
            temp['interfaceUsername'] = panelSuccessList[i]['interfaceUsername']
            temp['interfacePassword'] = panelSuccessList[i]['interfacePassword']
            temp['timezone'] = panelSuccessList[i]['timezone']
            temp['alertservice'] = panelSuccessList[i]['alertservice']
            temp['hmservice'] = panelSuccessList[i]['hmservice']
            successList.push(temp);
          }
        }
        let successDevList = successList.length;
        if (successDevList && successDevList !== undefined) {
          setSuccessDevices(successDevList)
        }

        const newList2 = []
        if (MULTI_TIME_ZONE) {
          newList2.push(["brand", "ipaddress", "sitezonename", "name", "zonetype", "zonename", "zonenumber", /* "interfacename", */ "portnumber", "interfaceusername", "interfacepassword", "timezone", "alertservice", "hmservice", "reason"])
        } else {
          newList2.push(["brand", "ipaddress", "sitezonename", "name", "zonetype", "zonename", "zonenumber", /* "interfacename", */ "portnumber", "interfaceusername", "interfacepassword", "alertservice", "hmservice", "reason"])
        }
        for (let i = 0; i < panelSuccessList.length; i++) {
          const element = panelSuccessList[i];
          if (MULTI_TIME_ZONE) {
            newList2.push([element["brand"], element["ipAddress"], element["siteName"], element["name"], element["zoneType"], element["zoneName"], element["zoneNumber"], /* element['interfaceName'],  */
            element["portNumber"], element["interfaceUsername"], element["interfacePassword"], element["timezone"], element['alertservice'], element['hmservice'],
            element["message"]])
          } else {
            newList2.push([element["brand"], element["ipAddress"], element["siteName"], element["name"], element["zoneType"], element["zoneName"], element["zoneNumber"], /* element['interfaceName'],  */
            element["portNumber"], element["interfaceUsername"], element["interfacePassword"], element['alertservice'], element['hmservice'],
            element["message"]])
          }
        }

        if (newList2 && newList2.length > 1) {
          setSucessListToDownload(newList2)
        }
      }
    } else if (type === "ACS") {
      const panelFailedLst = deviceBulkUploadResponse.FailedList;

      if (panelFailedLst && panelFailedLst.length > 0) {
        let failedList = []
        // if (sensorFailedLst.length > 0) failedList = failedList.concat(sensorFailedLst)
        if (panelFailedLst.length > 0) {
          for (let i = 0; i < panelFailedLst.length; i++) {
            // for (let j = 0; j < panelFailedLst[i].sensorLst.length; j++) {
            let temp = {};

            temp['sitezonename'] = panelFailedLst[i]['sitezonename']
            temp['brand'] = panelFailedLst[i]['brand']
            temp['message'] = panelFailedLst[i]['message']
            temp['ipaddress'] = panelFailedLst[i]['ipaddress']
            temp['devicename'] = panelFailedLst[i]['devicename']
            // temp['controllername'] = panelFailedLst[i]['controllername']
            temp['identifier'] = panelFailedLst[i]['identifier']
            temp['status'] = panelFailedLst[i]['status']
            // temp['interfaceName'] = panelFailedLst[i]['interfaceName']
            temp['portnumber'] = panelFailedLst[i]['portnumber']
            temp['username'] = panelFailedLst[i]['username']
            temp['password'] = panelFailedLst[i]['password']
            temp['alertservice'] = panelFailedLst[i]['alertservice']
            temp['hmservice'] = panelFailedLst[i]['hmservice']


            if (MULTI_TIME_ZONE) {
              temp['timezone'] = panelFailedLst[i]['timezone']
            }
            failedList.push(temp)
            // }
          }
        }
        let failedDevList = failedList.length;
        if (failedDevList && failedDevList !== undefined) {
          setFailedDevices(failedDevList)
        }

        const newList = []
        if (MULTI_TIME_ZONE) {
          newList.push(["brand", "sitezonename", "ipaddress", "portnumber", "username", "password", "devicename", "identifier", "timezone", "alertservice", "hmservice", "errorcause"])
        } else {
          newList.push(["brand", "sitezonename", "ipaddress", "portnumber", "username", "password", "devicename", "identifier", "alertservice", "hmservice", "errorcause"])
        }
        for (let i = 0; i < failedList.length; i++) {
          const element = failedList[i];
          // newList.push([element["brand"], element["panelIp"], element["sitename"], element["panelName"], element['sensorLst']["zoneType"], element['sensorLst']["zoneName"], element['sensorLst']["zoneNumber"], element['interfaceName'], element["message"]])
          if (MULTI_TIME_ZONE) {
            newList.push([element["brand"], element["sitezonename"], element["ipaddress"], element["portnumber"], element["username"], element["password"],  /* element['interfaceName'],  */
            element["devicename"], element["identifier"], element["timezone"], element["alertservice"], element["hmservice"],
            element["message"]])
          } else {
            newList.push([element["brand"], element["sitezonename"], element["ipaddress"], element["portnumber"], element["username"], element["password"], /* element['interfaceName'],  */
            element["devicename"], element["identifier"], element["alertservice"], element["hmservice"],
            element["message"]])
          }
        }

        if (newList && newList.length > 1) {
          setFaildListToDownload(newList)
        }
      } //end

      const panelSuccessList = deviceBulkUploadResponse.SuccessList

      if (panelSuccessList && panelSuccessList.length > 0) {
        let successList = []

        if (panelSuccessList.length > 0) {
          for (let i = 0; i < panelSuccessList.length; i++) {
            let temp = {}
            temp['branch'] = panelSuccessList[i]['branch']
            temp['sitezonename'] = panelSuccessList[i]['sitezonename']
            // temp['deviceID'] = panelSuccessList[i]['deviceID']
            temp['message'] = panelSuccessList[i]['message']
            temp['ipaddress'] = panelSuccessList[i]['ipaddress']
            temp['devicename'] = panelSuccessList[i]['devicename']
            // temp['controllername'] = panelSuccessList[i]['controllername']
            temp['identifier'] = panelSuccessList[i]['identifier']
            temp['status'] = panelSuccessList[i]['status']
            // temp['interfaceName'] = panelSuccessList[i]['interfaceName']
            temp['portnumber'] = panelSuccessList[i]['portnumber']
            temp['username'] = panelSuccessList[i]['username']
            temp['password'] = panelSuccessList[i]['password']
            temp['timezone'] = panelSuccessList[i]['timezone']
            temp['alertservice'] = panelSuccessList[i]['alertservice']
            temp['hmservice'] = panelSuccessList[i]['hmservice']
            successList.push(temp);
          }
        }
        let successDevList = successList.length;

        if (successDevList && successDevList !== undefined) {
          setSuccessDevices(successDevList)
        }

        const newList2 = []
        if (MULTI_TIME_ZONE) {
          newList2.push(["brand", "sitezonename", "ipaddress", "portnumber", "username", "password", "devicename", "identifier", "timezone", "alertservice", "hmservice", "reason"])
        } else {
          newList2.push(["brand", "sitezonename", "ipaddress", "portnumber", "username", "password", "devicename", "identifier", "alertservice", "hmservice", "reason"])
        }
        for (let i = 0; i < panelSuccessList.length; i++) {
          const element = panelSuccessList[i];
          if (MULTI_TIME_ZONE) {
            newList2.push([element["brand"], element["sitezonename"], element["ipaddress"], element["portnumber"], element["username"], element["password"],  /* element['interfaceName'],  */
            element["devicename"], element["identifier"], element["timezone"], element["alertservice"], element["hmservice"],
            element["message"]])
          } else {
            newList2.push([element["brand"], element["sitezonename"], element["ipaddress"], element["portnumber"], element["username"], element["password"],  /* element['interfaceName'],  */
            element["devicename"], element["identifier"], element["alertservice"], element["hmservice"],
            element["message"]])
          }
        }

        if (newList2 && newList2.length > 1) {
          setSucessListToDownload(newList2)
        }
      }

    } else if(type === "RTU" || type === "Fire Panel"){
      const panelFailedLst = deviceBulkUploadResponse.FailedList;

      if (panelFailedLst && panelFailedLst.length > 0) {
        let failedList = []
        // if (sensorFailedLst.length > 0) failedList = failedList.concat(sensorFailedLst)
        if (panelFailedLst.length > 0) {
          for (let i = 0; i < panelFailedLst.length; i++) {
            // for (let j = 0; j < panelFailedLst[i].sensorLst.length; j++) {
            let temp = {};

            temp['sitezonename'] = panelFailedLst[i]['sitezonename']
            temp['brand'] = panelFailedLst[i]['brand']
            temp['devicetype'] = panelFailedLst[i]['devicetype']
            temp['message'] = panelFailedLst[i]['message']
            temp['ipaddress'] = panelFailedLst[i]['ipaddress']
            temp['devicename'] = panelFailedLst[i]['devicename']
            // temp['controllername'] = panelFailedLst[i]['controllername']
            temp['identifier'] = panelFailedLst[i]['identifier']
            temp['status'] = panelFailedLst[i]['status']
            // temp['interfaceName'] = panelFailedLst[i]['interfaceName']
            temp['portnumber'] = panelFailedLst[i]['portnumber']
            temp['username'] = panelFailedLst[i]['username']
            temp['password'] = panelFailedLst[i]['password']
            temp['alertservice'] = panelFailedLst[i]['alertservice']
            temp['hmservice'] = panelFailedLst[i]['hmservice']


            if (MULTI_TIME_ZONE) {
              temp['timezone'] = panelFailedLst[i]['timezone']
            }
            failedList.push(temp)
            // }
          }
        }
        let failedDevList = failedList.length;
        if (failedDevList && failedDevList !== undefined) {
          setFailedDevices(failedDevList)
        }

        const newList = []
        if (MULTI_TIME_ZONE) {
          newList.push(["brand", "sitezonename", "devicetype", "ipaddress", "portnumber", "username", "password", "devicename", "identifier", "timezone", "alertservice", "hmservice", "errorcause"])
        } else {
          newList.push(["brand", "sitezonename", "devicetype", "ipaddress", "portnumber", "username", "password", "devicename", "identifier", "alertservice", "hmservice", "errorcause"])
        }
        for (let i = 0; i < failedList.length; i++) {
          const element = failedList[i];
          // newList.push([element["brand"], element["panelIp"], element["sitename"], element["panelName"], element['sensorLst']["zoneType"], element['sensorLst']["zoneName"], element['sensorLst']["zoneNumber"], element['interfaceName'], element["message"]])
          if (MULTI_TIME_ZONE) {
            newList.push([element["brand"], element["sitezonename"], element["devicetype"], element["ipaddress"], element["portnumber"], element["username"], element["password"],  /* element['interfaceName'],  */
            element["devicename"], element["identifier"], element["timezone"], element["alertservice"], element["hmservice"],
            element["message"]])
          } else {
            newList.push([element["brand"], element["sitezonename"], element["devicetype"], element["ipaddress"], element["portnumber"], element["username"], element["password"], /* element['interfaceName'],  */
            element["devicename"], element["identifier"], element["alertservice"], element["hmservice"],
            element["message"]])
          }
        }

        if (newList && newList.length > 1) {
          setFaildListToDownload(newList)
        }
      } //end

      const panelSuccessList = deviceBulkUploadResponse.SuccessList

      if (panelSuccessList && panelSuccessList.length > 0) {
        let successList = []

        if (panelSuccessList.length > 0) {
          for (let i = 0; i < panelSuccessList.length; i++) {
            let temp = {}
            temp['branch'] = panelSuccessList[i]['branch']
            temp['sitezonename'] = panelSuccessList[i]['sitezonename']
            temp['devicetype'] = panelSuccessList[i]['devicetype']
            temp['message'] = panelSuccessList[i]['message']
            temp['ipaddress'] = panelSuccessList[i]['ipaddress']
            temp['devicename'] = panelSuccessList[i]['devicename']
            temp['identifier'] = panelSuccessList[i]['identifier']
            temp['status'] = panelSuccessList[i]['status']
            temp['portnumber'] = panelSuccessList[i]['portnumber']
            temp['username'] = panelSuccessList[i]['username']
            temp['password'] = panelSuccessList[i]['password']
            temp['timezone'] = panelSuccessList[i]['timezone']
            temp['alertservice'] = panelSuccessList[i]['alertservice']
            temp['hmservice'] = panelSuccessList[i]['hmservice']
            successList.push(temp);
          }
        }
        let successDevList = successList.length;

        if (successDevList && successDevList !== undefined) {
          setSuccessDevices(successDevList)
        }

        const newList2 = []
        if (MULTI_TIME_ZONE) {
          newList2.push(["brand", "sitezonename", "devicetype", "ipaddress", "portnumber", "username", "password", "devicename", "identifier", "timezone", "alertservice", "hmservice", "reason"])
        } else {
          newList2.push(["brand", "sitezonename", "devicetype", "ipaddress", "portnumber", "username", "password", "devicename", "identifier", "alertservice", "hmservice", "reason"])
        }
        for (let i = 0; i < panelSuccessList.length; i++) {
          const element = panelSuccessList[i];
          if (MULTI_TIME_ZONE) {
            newList2.push([element["brand"], element["sitezonename"], element["devicetype"], element["ipaddress"], element["portnumber"], element["username"], element["password"],  /* element['interfaceName'],  */
            element["devicename"], element["identifier"], element["timezone"], element["alertservice"], element["hmservice"],
            element["message"]])
          } else {
            newList2.push([element["brand"], element["sitezonename"], element["devicetype"], element["ipaddress"], element["portnumber"], element["username"], element["password"],  /* element['interfaceName'],  */
            element["devicename"], element["identifier"], element["alertservice"], element["hmservice"],
            element["message"]])
          }
        }

        if (newList2 && newList2.length > 1) {
          setSucessListToDownload(newList2)
        }
      }
    }
  }

  const reset = () => {
    setSelectedEntity(0);
    setImportedFileName(null);
    setSheetUploadPayload(null);
    setFileData(null);
    setSheetCompliant(false);
    setHeaders(null);
  }

  const scrollToBottom = () => {
    // setTimeout(() => {
    //   divBottomRef.current?.scrollIntoView({ behavior: 'smooth' })
    // })
    setTimeout(() => {
      const el = containerRef.current;
      if(el){
        el.scrollTo({
          top: el.scrollHeight,
          behavior: 'smooth'
        })
      }
    }, 500)
  }

  return (
    <div className='MainContentMargin'>
      <div className="col-lg-12 TabulerReportMainDiv">
        <div className="card-body p-0">
          <div style={{ height: 800, width: "100%", padding: "15px" }}>
            <div className="siteformContainer" ref={containerRef} style={{ height: "81vh" }}>
              <div className="site-form" style={{ display: "flex", flexDirection: "column" }}>
                <div className=" mb-5" >                  
                  <AlertTemplateMessage
                  // message={`This template supports both adding new records and updating existing ones. If data already exists, the corresponding record will be updated with the values provided in the template. Please use with caution, as incorrect data may overwrite existing information.`} 
                  message={`This template supports only the addition of new records. Existing data will not be updated. Please ensure that you do not include duplicate or previously added entries.`}
                  />
                </div>

                <h5 className="DownloadTemplate_Header">Download Template</h5>
                <div className="inputMainContainer w40dot75rem mb-5">
                  <div style={{ display: "flex" }}>
                    <div className="inputTypeLabelContainer" style={{ width: "95%" }}>
                      <label className='formFieldLabels'>Select Entity</label>
                      <select className="inputType ArrowSelectClass" value={selectedEntity} onChange={(e) => {
                        setSelectedEntity(e.target.value)
                        setImportedFileName(null);
                        setSheetUploadPayload(null);
                        setFileData(null);
                        setSheetCompliant(false);
                        setErrorMessages([]);
                        setHeaders(null);
                        setCustomerResult([]);
                        setSiteResult([]);
                        setFailedDevices(null)
                        setSuccessDevices(null);
                        }}>
                        <option key="0" disabled={false} value={0} id="0">Select Entity*</option>
                        {
                          entityData.map((item) => (
                            <option value={item.id} key={item.id}>{item.name}</option>
                          ))
                        }
                        {/* <option>Site</option>
                                <option>Interface</option>
                                <option>Devices</option>
                                <option>Users</option> */}
                      </select>
                    </div>
                    <button disabled={selectedEntity === 0} className="addCustomer" style={{ marginLeft: "10px" }} onClick={downloadFile}>
                      <span className="ViewUpdate">
                        Download
                      </span>
                    </button>
                  </div>
                </div>

                <h5 className='DownloadTemplate_Header'>Upload Data</h5>
                <div className="inputMainContainer w40dot75rem">
                  <div className="BulkUploadBrowseDiv">
                    <input className="BulkUploadInput" value={importedFileName || ""} disabled={true} style={{ width: "calc(100% - 110px)" }} />
                    <input
                      type="file"
                      accept='.xlsx, .xls, .csv'
                      multiple={false}
                      ref={hiddenPanelFileInput}
                      onChange={(e) => handleUploaderChange(e)}
                      style={{ display: "none" }}
                      value=""
                    />
                    <button className="DataAccessEdit" style={{ width: "100px" }} disabled={selectedEntity == 0} onClick={handleBrowse}>
                      <span className="ViewUpdate">Browse</span>
                    </button>
                  </div>
                </div>

                <div style={{ textAlign: "center" }}>
                  <button className="DataAccessEdit" style={{ width: "100px" }} disabled={importedFileName === null} onClick={validateSheet} >
                    <span className="ViewUpdate">Validate</span>
                  </button>
                  <button className="DataAccessEdit" disabled={!sheetCompliant || uploadSpinner} style={{ width: "100px" }} onClick={bulkUpload}>
                    <span className="ViewUpdate">
                      {uploadSpinner ? 'Uploading': 'Upload'}
                    </span>
                  </button>
                </div>

                <div className='col-lg-12 mt-2' style={{ width: "100%" }}>
                  {/* <AlertTemplateMessage
                          message={
                            "Error comes here."
                          }
                        /> */}
                  <div className="code-snippet-container">
                    <button onClick={handleCopy} className="copy-button">
                      {copied ? "Copied!" : "Copy"}
                    </button>
                    <div 
                    ref={textRef}
                    style={{
                      color: 'black',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'start'
                    }}>
                    {
                      errorMessage.map((item, index) => (
                        <div 
                          style={{
                            display: 'flex',
                            textAlign: 'left'
                          }}
                         className='childError' key={index}>{item.message}</div>
                      ))
                    }
                    </div>
 
                    <pre ref={codeRef}>
                    {/* {
                      errorMessage.map((item, index) => (
                        <code key={index}>{item.message}</code>
                      ))
                    } */}
                      {/* <code>
                        {
                          errorMessage.map((item, index) => (
                            <span map="">{item.message}</span>
                          ))
                        }
                      </code> */}
                    </pre>
                  </div>
                </div>
                <div style={{textAlign: 'center'}}>
                  {
                    failedDevices && failedDevices != 0 &&
                    <span className="bulk-upload-msg-text template-name">
                      <CSVLink filename={"BulkUploadFailedList.csv"} className="mendat-fields" data={faildListToDownload}>Failed Uploads</CSVLink> </span>
                  }
                  {
                    successDevices && successDevices != 0 &&
                    <span className="bulk-upload-msg-text template-name">
                      <CSVLink filename={"BulkUploadSuccessList.csv"}
                        className="mendat-fields"
                        data={sucessListToDownload}>
                        Successful Uploads
                      </CSVLink>
                    </span>
                  }

                  {
                    (customerResult.length > 0 || siteResult.length > 0) &&
                    <span className="bulk-upload-msg-text template-name">
                      <button
                        onClick={handleDownload}
                        className='mendat-fields'
                        style={{
                          background: 'none',
                          border: 'none',
                          padding: 0,
                          color: '#007bff',
                          textDecoration: 'underline',
                          cursor: 'pointer',
                          font: 'inherit'
                        }}
                      >
                        Bulk Upload Status Sheet
                      </button>                 
                    </span>
                  }

                </div>
                <div ref={divBottomRef} />
              </div>

              <div className="site-form" style={{ display: "none", flexDirection: "column" }}>

                <div className="inputMainContainer w40dot75rem mb-5">
                  <div className="inputTypeLabelContainer">
                    <label className='formFieldLabels'>Select Entity</label>
                    <select className="inputType ArrowSelectClass">
                      <option key="0" disabled={false} value="0" id="0">Select Entity*</option>
                      <option>Site</option>
                      <option>Interface</option>
                      <option>Devices</option>
                      <option>Users</option>
                    </select>
                  </div>
                </div>

                <h5 style={{ textAlign: "left" }}>Select fields</h5>
                <div className="CameraFilterList">
                  <div className="OneList">
                    <p className="ListofText">
                      <span>Username</span>
                    </p>
                    <div style={{ display: "flex", alignItems: "center" }}> <div className="ml-3">
                      <input type="checkbox" checked={true} />
                    </div>
                    </div>
                  </div>
                  <div className="OneList">
                    <p className="ListofText">
                      <span>Email ID</span>
                    </p>
                    <div style={{ display: "flex", alignItems: "center" }}> <div className="ml-3">
                      <input type="checkbox" checked={true} />
                    </div>
                    </div>
                  </div>
                  <div className="OneList">
                    <p className="ListofText">
                      <span>Address</span>
                    </p>
                    <div style={{ display: "flex", alignItems: "center" }}> <div className="ml-3">
                      <input type="checkbox" checked={true} />
                    </div>
                    </div>
                  </div>
                  <div className="OneList">
                    <p className="ListofText">
                      <span>Address 1</span>
                    </p>
                    <div style={{ display: "flex", alignItems: "center" }}> <div className="ml-3">
                      <input type="checkbox" checked={true} />
                    </div>
                    </div>
                  </div>
                  <div className="OneList">
                    <p className="ListofText">
                      <span>Mobile User</span>
                    </p>
                    <div style={{ display: "flex", alignItems: "center" }}> <div className="ml-3">
                      <input type="checkbox" checked={true} />
                    </div>
                    </div>
                  </div>
                </div>


                <div style={{ textAlign: "center" }}>
                  <button className="DataAccessEdit" style={{ width: "180px" }} >
                    <span className="ViewUpdate">Export Details</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Import